import { apis } from '../apiBase/apiBase';
export const taskTemplateApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getTaskTemplates: builder.query({
            query: (params) => ({
                url: `task-templates`,
                params: params,
            }),
        }),
        // タスクテンプレート詳細取得
        getTaskTemplate: builder.query({
            query: (params) => ({
                url: `task-templates/${params.taskTemplateId}`,
                method: 'GET',
            }),
        }),
        // タスクテンプレートロード
        loadTaskTemplate: builder.query({
            query: (params) => ({
                url: `task-templates/load/${params.taskTemplateId}`,
                params: {
                    projectId: params.projectId,
                },
                method: 'GET',
            }),
        }),
        // タスクテンプレート登録API
        insertTaskTemplate: builder.mutation({
            query: (params) => ({
                url: 'task-templates/insert',
                method: 'POST',
                body: params,
            }),
        }),
        // タスクテンプレート更新API
        updateTaskTemplate: builder.mutation({
            query: (params) => ({
                url: 'task-templates/update',
                method: 'POST',
                body: params,
            }),
        }),
        // タスクテンプレート削除API
        deleteTaskTemplate: builder.mutation({
            query: (params) => ({
                url: `task-templates/delete`,
                method: `POST`,
                body: params,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetTaskTemplatesQuery, useLazyGetTaskTemplatesQuery, useGetTaskTemplateQuery, useLazyGetTaskTemplateQuery, useLoadTaskTemplateQuery, useLazyLoadTaskTemplateQuery, useInsertTaskTemplateMutation, useUpdateTaskTemplateMutation, useDeleteTaskTemplateMutation, } = taskTemplateApis;
